<template>
  <Page>
    <div class="header">
      <img src="@/assets/logo.jpg" alt="logo" class="logo">
      <div>直播间</div>
    </div>

    <div class="page-title">展商直播live</div>

    <div class="live-box">
      <div class="title-box">
        <div class="left">
          <div class="name">XXXXXXX直播</div>
          <div class="btn live">直播中</div>
          <div class="btn replay">回放</div>
          <div class="btn fill-live">直播中</div>
          <div class="btn fill-load">即将直播</div>
        </div>
        <div class="right">
          <!-- <div class="btn">举报</div> -->
        </div>
      </div>

      <div class="con">
        <div class="left">
          <div class="zhead">
            <div class="name-box">
              <img src="@/assets/footer-logo.png" alt="">
              <h4 class="ell">佛山新媒体科技有限公司</h4>
              <div class="zan">12302</div>
            </div>
            <img v-if="nowtimestamp>timestamp" src="@/assets/icon-full.png" alt="全屏" @click="full">
          </div>
          <div class="playbox">
            
            <div id="live_video"></div>
            <!--倒计时-->
            <div class="count-box" v-if="nowtimestamp<timestamp">
              <div class="mask"></div>
              <div class="count">
                <div>2020谭洲国际陶瓷展</div>
                <div>
                  {{countData.day}}<span>天</span>
                  {{countData.hours}}<span>时</span>
                  {{countData.minuts}}<span>分</span>
                  {{countData.second}}<span>秒</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="tit">直播信息</div>
          <div class="detail">
            <!-- <div class="label">直播标题</div> -->
            <div class="title">2020谭洲国际陶瓷展</div>
            <div class="label">直播简介</div>
            
            <div class="intro">
              <p>2020年，佛山（潭洲）国际陶瓷展定于2020年7月20日—24日在中国·佛山·潭洲国际会展中心举办，分为产品与应用技术区、装备与材料区两大展区，120000平方米，可提供5000个摊位。展会由佛山市人民政府为指导单位，由佛山陶联科技发展有限公司为主办单位，广东省建筑材料行业协会、广东陶瓷协会、佛山市陶瓷行业协会为支持单位。</p>
              <p>展会设有岩板和定制馆、原创IP馆、发泡陶瓷馆、联合采购招标馆、国际馆等10个专业主题馆，聚合全产业链力量，向大众展示陶瓷行业最新产品、技术及应用。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabbox">
      <div class="tab active">正在直播</div>
      <div class="tab">即将直播</div>
      <div class="tab">直播回放</div>
    </div>

    <div class="zb-list">
      <a class="list" v-for="item in list">
        <div class="img-box">
          <img src="http://www.uniceramics.com.cn/temp/001-min.jpg" alt="">
          <div class="btn fill-live">直播中</div>
          <div class="company">
            <img src="@/assets/temp/user.jpg" />
            <div class="ell">公司名称很长很长很长很长很长很长</div>
          </div>
        </div>
        <div class="ell">直播标题很长很长很长很长很长很长很长很长很长很长</div>
        <div class="area">所属地区: 家居装饰品</div>
        <div class="start-time">开始时间: 2020-07-20 14:30</div>
      </a>
    </div>

  </Page>
</template>

<script>
import Page  from '@/components/page.vue'

export default {
  name: '',
  components:{Page},
  data(){
    return {
      startTime:'2020/07/16 09:30:00',
      countData:{day:0, hours:0, minute:0, second:0},
      timestamp : (new Date(this.startTime)).getTime(),
      nowtimestamp : (new Date()).valueOf(),
      sw: document.documentElement.clientWidth,
      videoWidth:0,
      videoHeight:0,
      list:[1,2,3,4,5,6],
      livePlayer:null,
    }
  },
  mounted(){
    window.onresize = ()=>{
      this.sw = document.documentElement.clientWidth;
      this.setPlayerSize();
    };
    this.setPlayerSize();
    this.liveInit();
    let count = ()=>{
      this.showtime();
      this.timestamp = (new Date(this.startTime)).getTime(); //直播时间戳
      this.nowtimestamp = (new Date()).valueOf(); //现在时间戳
      setTimeout(count,1000)
    }
    count();
  },
  computed:{
    lang(){return this.$store.state.index.lang}
  },
  methods:{
    full(){
      this.livePlayer.fullscreen(true);
    },
    setPlayerSize(){
      if(this.sw>991){
        this.videoWidth = this.sw/100*61.6;
        this.videoHeight = this.sw/100*39.7;
      }else{
        this.videoWidth = this.sw/100*95.4;
        this.videoHeight = this.sw/100*51;
      }
    },
    liveInit(){
      let options = {
          "m3u8": "http://zhibo.uniceramics.com.cn/live/0630.m3u8", //请替换成实际可用的播放地址
          "rtmp":"rtmp://zhibo.uniceramics.com.cn/live/0630",
          "flv": "http://zhibo.uniceramics.com.cn/live/0630.flv", 
          "autoplay" : true,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          "poster" : "http://www.uniceramics.com.cn/temp/001.jpeg",
          "width" :  this.videoWidth,//视频的显示宽度，请尽量使用视频分辨率宽度
          "height" : this.videoHeight,//视频的显示高度，请尽量使用视频分辨率高度
          "wording":{
            "1002":"直播暂未开始！",
            "4":"直播暂未开始！",
            "2":"直播暂未开始！"
          },
          listener: function (msg) {
              // console.log(msg);
              if(msg.type=='error'){
              }
          },
          error:function(err){
            console.log(err);
          }
        }
        this.livePlayer = new TcPlayer('live_video',options);
    },
    showtime(){
        let nowtime = new Date(),
            endtime = new Date(this.startTime);
        let lefttime = endtime.getTime() - nowtime.getTime();  //距离结束时间的毫秒数
        let leftd = Math.floor(lefttime/(1000*60*60*24)),  //计算天数
            lefth = Math.floor(lefttime/(1000*60*60)%24),  //计算小时数
            leftm = Math.floor(lefttime/(1000*60)%60),  //计算分钟数
            lefts = Math.floor(lefttime/1000%60);  //计算秒数
        this.countData = {day:leftd, hours:lefth, minute:leftm, second:lefts};
        // console.log(this.countData);
      }
  },
  watch:{
    'sw':function(val){
      this.livePlayer.size(this.videoWidth, this.videoHeight);
    } 
  },
  i18n:{
    messages: {
      zh: { 
        t1: '直播',
       
      },
      en:  { 
        t1: 'live',
      }
    }
  }
}
</script>

<style scoped>
.btn{height:1.3vw; line-height:1.3vw; border-radius:1.3vw; font-size:0.8vw; text-align:center; padding:0.1vw 0.9vw; display:flex; align-items:center;}

.btn.live{color:#6df956; border:1px solid #6df956;}
.btn.live:before{content:''; display:inline-block; width:0.3vw; height:0.3vw; background:#6df956; border-radius:0.3vw; margin-right:0.4vw;}
.btn.replay{color:#d47510; border:1px solid #d47510;}
.btn.replay:before{content:''; display:inline-block; width:0.3vw; height:0.3vw; background:#d47510; border-radius:0.3vw; margin-right:0.4vw;}
.btn.fill-live{background:#d61f26; color:#fff; border:1px solid #d61f26;}
.btn.fill-live:before{content:''; display:inline-block; width:0.3vw; height:0.3vw; background:#fff; border-radius:0.3vw; margin-right:0.4vw;}
.btn.fill-load{background:#fff; color:#d61f26; border:1px solid #fff;}
.btn.fill-load:before{content:''; display:inline-block; width:0.3vw; height:0.3vw; background:#d61f26; border-radius:0.3vw; margin-right:0.4vw;}


.header{height:10.4vw; background:#f2f2f2; display:flex; align-items:center; padding-left:2.3vw;}
.header>img{height:6.5vw; margin-right:3.1vw;}
.header>div{height:1.72vw; line-height:1.72vw; border-left:4px solid #333; font-size:1.6vw; padding-left:0.8vw; font-weight:bold;}

.page-title{font-size:1.7vw; font-weight:bold; padding:2vw 0 1.5vw 2.3vw;}

.live-box{margin:0 2.3vw 2vw 2.3vw; background:#141419; height:47.6vw; overflow:hidden;}
.live-box .title-box{color:#fff; background:#36383f; box-shadow:0 2px 1vw #000; height:3.75vw; padding:0 1vw; display:flex; justify-content: space-between;}
.live-box .title-box .left{display:flex; align-items:center;}
.live-box .title-box .left .name{font-size:1.2vw; line-height:3.75vw; margin-right:1vw;}
.live-box .title-box .left .btn{margin-right:0.4vw;}

.live-box .con{display:flex; color:#fff; height:43.6vw;}
.live-box .con .left{flex:0 0 61vw; width:61vw; border-right:1px solid #3b3b4a;}
.live-box .con .left .zhead{height:4.4vw; background:#2a2b31; display:flex; align-items:center; justify-content:space-between;}
.live-box .con .left .zhead .name-box{height:2.7vw; width:16.2vw; margin-left:1vw; padding:0.2vw 0 0.2vw 2.9vw; background:#1d1d1d; color:#fff; border-radius:2.7vw; position: relative; display:flex; flex-direction: column; justify-content:center;}
.live-box .con .left .zhead .name-box img{height:2.3vw; height:2.3vw; position: absolute; top:0.2vw; left:0.2vw;}
.live-box .con .left .zhead .name-box>*{font-size:0.7vw;}
.live-box .con .left .zhead>img{width:2vw; height:2vw; margin-right:2vw; cursor:pointer; transition-duration:300ms; transform:scale(0.9);}
.live-box .con .left .zhead>img:hover{transform:scale(1);}
.live-box .con .left .playbox{width:61vw; height:39.2vw; font-size:0; position: relative;}
.live-box .con .left .playbox .count-box{position:absolute; z-index:999; top:0;bottom:0;right:0;left:0; background:url("http://www.uniceramics.com.cn/temp/001.jpeg") no-repeat; background-size:100% 100%;}
.live-box .con .left .playbox .count-box .mask{position: absolute;top:0;bottom:0;left:0;right:0; background:rgba(0,0,0,.5);}
.live-box .con .left .playbox .count-box .count{position: absolute;top:0;bottom:0;left:0;right:0; color:#fff; font-size:2vw; text-align:center; display:flex; justify-content:center; flex-direction:column;}
.live-box .con .left .playbox .count-box .count>div:nth-of-type(1){font-size:3vw; padding:1vw;}
.live-box .con .left .playbox .count-box .count>div>span{margin:0 0.5vw; display:inline-block; transform:scale(0.7); transform-origin:center 1.8vw;}

.live-box .con .right{flex:1 1 auto;}
.live-box .con .right .tit{height:4.4vw; line-height:4.4vw; background:#2a2b31; font-size:1.5vw; text-align:center;}
.right .detail{padding:1.5vw 1.5vw 1vw 1.5vw;}
.right .detail .label{border-left: 0.2vw solid #d61217; padding-left:0.5vw; margin:1vw 0; font-size:1vw;}
.right .detail .title{font-size:1.2vw; line-height:2vw; text-align:center;}
.right .detail .intro{overflow-y:auto; height:27vw; font-size:0.9vw; line-height:1.6vw;}

.tabbox{margin:3vw 2.3vw 2vw 2.3vw; display:flex; align-items:flex-end;}
.tabbox>.tab{width:10vw; font-size:1.6vw; font-weight:bold; color:#666; transition-duration:300ms; cursor:pointer;}
.tabbox>.tab.active,
.tabbox>.tab:hover
{font-size:1.7vw; color:#111;}

.zb-list{margin:2vw 2.3vw 2vw 2.3vw; font-size:0;}
.zb-list .list{display:inline-block; width:23.5%; margin-right:2%; border:1px solid #ccc; box-sizing:border-box; color:#333; margin-bottom:1.4vw; padding-bottom:0.5vw;}
.zb-list .list:nth-of-type(4n){margin-right:0;}
.zb-list .list .img-box{position: relative; width:19.3vw; height:10.9vw;}
.zb-list .list .img-box>img{width:19.3vw; height:10.9vw; object-fit:cover;}
.zb-list .list .img-box .btn{position: absolute; top:1vw; right:1vw;}
.zb-list .list .img-box .company{position:absolute; bottom:0.8vw; left:0.8vw; width:12vw; height:1.76vw; line-height:1.76vw; background:rgba(0,0,0,.6); color:#fff; font-size:0.7vw; display:flex; border-radius:1.56vw;}
.zb-list .list .img-box .company img{width:1.76vw; height:1.76vw; border-radius:1.56vw; object-fit:cover;}
.zb-list .list .img-box .company .ell{width:80%;}
.zb-list .list>.ell{padding:0.5vw 0.4vw; font-size:1.2vw; width:99%; margin-top:0.5vw;}
.zb-list .list>.area,
.zb-list .list>.start-time{font-size:1vw; padding:0.2vw 0.4vw;}



@media (max-width:991px){
.btn{height:3vw; line-height:3vw; border-radius:3vw; font-size:1.6vw; text-align:center; padding:0.3vw 2vw; display:flex; align-items:center;}

.header{display:none;}

.page-title{font-size:3.5vw; font-weight:bold; padding:4.5vw 0 1.5vw 2.3vw;}
.live-box{margin:0 2.3vw 4vw 2.3vw; height:auto;}
.live-box .title-box{box-shadow:0 2px 1vw #000; height:8vw; padding:0 2vw; }
.live-box .title-box .left .name{font-size:2.2vw;  margin-right:2.6vw;}
.live-box .title-box .left .btn{margin-right:2vw;}

.live-box .con{height:auto; flex-wrap:wrap;}
.live-box .con .left{flex:0 0 95.4vw;}
.live-box .con .left .zhead{height:12vw; background:#2a2b31;}
.live-box .con .left .zhead .name-box{height:7.5vw; width:35vw; margin-left:1vw; padding:0.4vw 0 0.2vw 8vw; border-radius:7vw; }
.live-box .con .left .playbox{width:95.4vw; height:51vw;}
.live-box .con .left .playbox .count-box .count{font-size:6vw;}
.live-box .con .left .playbox .count-box .count>div:nth-of-type(1){font-size:6vw; padding:2vw;}
.live-box .con .left .playbox .count-box .count>div>span{margin:0 0.5vw; display:inline-block; transform:scale(0.7); transform-origin:center 5.8vw;}

.live-box .con .left .zhead .name-box img{height:6.5vw; height:6.5vw;  top:0.5vw; left:0.5vw;}
.live-box .con .left .zhead .name-box h4{font-size:2.5vw;}
.live-box .con .left .zhead .name-box .zan{font-size:2.4vw;}
.live-box .con .left .zhead>img{width:5vw; height:5vw; margin-right:4vw;}


.live-box .con .right{flex:0 0 95.4vw;}
.live-box .con .right .tit{height:12vw; line-height:12vw; font-size:3.4vw;}
.right .detail{padding:3vw 1.5vw 3vw 1.5vw;}
.right .detail .label{border-left: 0.5vw solid #d61217; padding-left:1vw; margin:2vw 0; font-size:3.2vw;}
.right .detail .title{font-size:4vw; line-height:6vw;}
.right .detail .intro{height:auto; font-size:3vw; line-height:4.5vw;}


.tabbox{margin:6vw 2.3vw 4vw 2.3vw; }
.tabbox>.tab{width:17vw; font-size:2.9vw; }
.tabbox>.tab.active,
.tabbox>.tab:hover
{font-size:3.2vw; }

.zb-list .list{width:48%; margin-right:4%; margin-bottom:1.4vw; padding-bottom:0.5vw;}
.zb-list .list:nth-of-type(2n){margin-right:0;}
.zb-list .list .img-box{position: relative; width:45.5vw; height:26vw;}
.zb-list .list .img-box>img{width:45.5vw; height:26vw; object-fit:cover;}
.zb-list .list .img-box .btn{top:1.5vw; right:1.5vw;}

.zb-list .list .img-box .company{position:absolute; bottom:1.8vw; left:1.8vw; width:40vw; height:5vw; line-height:5vw; font-size:1.7vw; border-radius:5vw;}
.zb-list .list .img-box .company img{width:5vw; height:5vw; border-radius:5vw; object-fit:cover;}
.zb-list .list .img-box .company .ell{width:80%;}

.zb-list .list>.ell{padding:1vw 1vw; font-size:2.7vw; width:95%; margin-top:1vw;}
.zb-list .list>.area,
.zb-list .list>.start-time{font-size:2.4vw; padding:0.6vw 1vw;}



}
</style>

